export default __webpack_public_path__ + "static/media/Leg_right.2001da8e.svg";